import { AiAgentProfileHoverCard } from "@circle-react/components/Profile/AiAgentHoverCard";
import { ProfileHoverCard } from "@circle-react/components/Profile/HoverCard";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useProfileLinkProps } from "@circle-react/hooks/profile/useProfileLinkProps";

import { UserImage } from "@/react/components/SettingsApp/CompassCompat/UserImage";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";
import { useAgentProfileLinkProps } from "@/react/hooks/agent_profile/useAgentProfileLinkProps";
import type { Comment } from "@/react/types/Comment";

export interface MemberAvatarProps {
  comment: Comment;
}

export const MemberAvatar = ({ comment }: MemberAvatarProps) => {
  const { community_member, author_type: authorType } = comment;

  const profileLinkProps = useProfileLinkProps({
    public_uid: community_member.public_uid ?? "",
    params: { show_back_link: true },
  });

  const agentProfileLinkProps = useAgentProfileLinkProps({
    id: community_member.id,
    params: { show_back_link: true },
  });

  return (
    <div
      className={classNames(anchorClassNames("post__user"), "flex items-start")}
    >
      <div className={classNames(anchorClassNames("post__avatar"), "mr-3")}>
        <a
          className={classNames(
            anchorClassNames("user__avatar"),
            "focus-visible:outline-secondary focus-visible:text-dark block size-10 focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
          )}
          {...(authorType === "CommunityAiAgent"
            ? agentProfileLinkProps
            : profileLinkProps)}
        >
          {authorType === "CommunityAiAgent" ? (
            <AiAgentProfileHoverCard
              communityMemberId={community_member.id}
              name={community_member.name}
              publicUid={community_member.public_uid}
              avatarURL={community_member.avatar_url}
            >
              <UserImage
                src={community_member.avatar_url ?? ""}
                name={community_member.name ?? ""}
                size="10"
              />
            </AiAgentProfileHoverCard>
          ) : (
            <ProfileHoverCard
              communityMemberId={community_member.id}
              name={community_member.name}
              publicUid={community_member.public_uid}
              headline={community_member.headline}
              avatarURL={community_member.avatar_url}
            >
              <UserImage
                src={community_member.avatar_url ?? ""}
                name={community_member.name ?? ""}
                size="10"
              />
            </ProfileHoverCard>
          )}
        </a>
      </div>
    </div>
  );
};
